export const mapTopTiersToAnalyticsRows = (tiersCounts, tiersNames) => {
    if (!tiersCounts || !tiersCounts.length || !tiersNames)
        return [];
    const tiersData = tiersCounts.map((tiersCount) => ({
        ...tiersCount,
        ...tiersNames.find((tiersName) => tiersName.id === tiersCount.tierId),
    }));
    return tiersData.map(({ name, count }) => ({
        label: name,
        value: count,
    }));
};
